import { parseCampaignVariant } from '@schuelerhilfe/shared/src/enums/campaign';

/** Set on `<main>` by `LiveRenderTree` — the rendered Page's variant. */
const VARIANT_ATTRIBUTE = 'data-campaign-variant';

/** What a page without a campaign variant of its own is in. */
const DEFAULT_VARIANT = 'a';

/**
 * The campaign variant of the page on screen, lowercased — what GA4's
 * `campaign_variant` and a form's `sourceUrl` report.
 *
 * The rendered Page's variant, not the visitor's `sh_campaign` cookie
 * (SH-471): a visitor holding `c` on a page without a campaign template sees
 * variant A, and reporting `c` there would attribute data to a variant that was
 * never shown. Read from the DOM rather than from `useCampaign()`, so it also
 * works outside the React tree (event handlers, Header, Footer), and it matches
 * the HTML actually served, including a page the CDN served from cache.
 *
 * Kill switch for Campaign Variants (SH-289) — see proxy.ts. Disabled means
 * every request is forced to variant A.
 */
export function activeCampaignVariant(): string {
  if (process.env.NEXT_PUBLIC_CAMPAIGN_VARIANTS_ENABLED === 'false') {
    return DEFAULT_VARIANT;
  }
  if (typeof document === 'undefined') {
    return DEFAULT_VARIANT;
  }
  const raw = document
    .querySelector(`[${VARIANT_ATTRIBUTE}]`)
    ?.getAttribute(VARIANT_ATTRIBUTE);
  return parseCampaignVariant(raw)?.toLowerCase() ?? DEFAULT_VARIANT;
}
